// extracted by mini-css-extract-plugin
export default {"container":"PageTitle_container__SHJRY","title":"PageTitle_title__349Yo","subtitle":"PageTitle_subtitle__-oxIn","separator":"PageTitle_separator__3jadR"};